module.exports = __webpack_public_path__ + "img/recode.d0289dc0.png";